
import { motion } from 'framer-motion';
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Active Member',
      hmu: '5,234',
      avatar: 'SJ',
      rating: 4.9,
      text: 'HoneyJar changed how I learn and shop. I\'ve earned over 5,000 HMUs in just two months! The missions are engaging, and I love that every purchase I make earns me rewards. It\'s like getting paid to improve myself.',
    },
    {
      name: 'Michael Chen',
      role: 'Master Tier',
      hmu: '12,890',
      avatar: 'MC',
      rating: 5.0,
      text: 'The gamification aspect keeps me motivated every day. I\'ve completed 50+ learning modules and redeemed amazing merchandise. The streak bonuses are addictive in the best way possible!',
    },
    {
      name: 'Emily Rodriguez',
      role: 'Achiever',
      hmu: '8,456',
      avatar: 'ER',
      rating: 4.8,
      text: 'Best platform for earning while learning! The e-commerce integration is seamless, and I love earning HMUs from my regular shopping. Already redeemed two hoodies and a digital course bundle.',
    },
  ];

  const current = testimonials[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl font-serif text-charcoal-800 text-center mb-16"
        >
          What Our <span className="italic">Community</span> Says
        </motion.h2>

        {/* Review Card */}
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-3xl p-12 shadow-xl"
        >
          {/* Rating Badge */}
          <div className="inline-flex items-center gap-2 bg-charcoal-800 text-white px-4 py-2 rounded-full mb-6">
            <i className="ri-star-fill text-yellow-400"></i>
            <span className="font-bold">{current.rating}</span>
          </div>

          {/* Review Text */}
          <blockquote className="text-2xl text-charcoal-700 leading-relaxed mb-8 font-serif">
            "{current.text}"
          </blockquote>

          {/* User Info */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-honey-400 to-honey-600 flex items-center justify-center text-white font-bold text-lg ring-4 ring-honey-200">
              {current.avatar}
            </div>
            <div>
              <div className="font-bold text-charcoal-800 text-lg">{current.name}</div>
              <div className="text-gray-600 text-sm">
                {current.role} • {current.hmu} HMUs earned
              </div>
            </div>
          </div>
        </motion.div>

        {/* Navigation */}
        <div className="flex justify-end gap-3 mt-8">
          <button
            onClick={handlePrev}
            className="w-12 h-12 flex items-center justify-center bg-white border-2 border-gray-300 rounded-lg hover:border-charcoal-800 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl text-charcoal-800"></i>
          </button>
          <button
            onClick={handleNext}
            className="w-12 h-12 flex items-center justify-center bg-charcoal-800 rounded-lg hover:bg-charcoal-700 transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl text-white"></i>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-2 mt-6">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                index === currentIndex ? 'bg-honey-500 w-8' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
